<template>
  <div v-if="!isPrint">
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 점검정보 -->
    <write-grid-container title="점검정보" v-model="form.subInfo" :options="gridContainerOptions">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input" v-if="dataType === 'date'">{{form.subInfo[value]}}</div>
          <div class="print-input" v-else>{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <date-selector v-if="dataType === 'date'" class="w-full" v-model="form.subInfo[value]" />
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" />
        </div>
      </template>
    </write-grid-container>

    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="form.inspectTitle"
      table-header-title="점검항목"
      table-header-check-title="평가"
      :table-header-check="[{ text: '적정' }, { text: '보통' }, { text: '미흡'}, {text: '해당없음'}]"
      :tableHeaderNote="[{ text: '비고', mobileText: '비고', width:  200},]"
      content-before="numbering"
      v-model="form.inspectList"
      class="mt-5"
      use-kakao
      @update-kakao-phone-number="form.kakaoPhoneNumber = $event"
    />

    <!-- 파일첨부 -->
    <file-upload-module title="파일첨부" :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
  <print v-else :board="board" :form="form"/>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "./inspectData";
import Print from "./Print.vue";

export default {
  components: {
    TableInspectMerge,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
    Print
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      gridContainerOptions: {
        dataTypes: ["date", "string", "string"],
        labels: ["점검일", "소속명", "점검자"],
        values: ["점검일", "소속명", "점검자"],
      },

      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},
        inspectList: JSON.parse(JSON.stringify(inspectData.inspectTable)),
        inspectTitle: "유해·위험기계·기구 및 설비 관리",
        kakaoPhoneNumber: "",
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // subInfo 초기화
    this.form.subInfo = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = '';
      return acc;
    }, {})

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
